<script>
export default {
  props: ['text', 'initWithDefaultSearchTerm'],
  data() {
    return {
      query: '',
      isFocus: false,
      defaultQuery: '',
    };
  },
  methods: {
    submitQuery(e) {
      e.preventDefault();
      this.$emit('user-submit');
    },
  },
  watch: {
    query: function (newVal, oldVal) {
      this.$emit('update-request', 'FreeText', newVal, false, false);
    },
  },
  mounted() {
    this.$nextTick(function () {
      this.query = this.initWithDefaultSearchTerm;
    });
  },
};
</script>

<template>
  <form
    :title="this.text"
    @submit.prevent(submitQuery)
    :class="{ 'is--focused': isFocus }"
    class="search--input--container form-control"
    ref="search"
  >
    <input
      :aria-label="this.text"
      type="text"
      :alt="this.text"
      :title="this.text"
      :name="this.text"
      v-model="query"
      @focus="isFocus = true"
      @blur="isFocus = false"
      :placeholder="this.text"
    />
    <transition name="fade" mode="in-out">
      <button
        @click="this.submitQuery"
        type="submit"
        v-if="!isFocus"
        class="d-flex align-items-center justify-content-center search--btn"
      >
        <span class="material-icons">search</span>
      </button>
      <button
        type="submit"
        @click="this.submitQuery"
        v-else
        class="d-flex search--btn align-items-center active justify-content-center"
      >
        <span class="material-icons blue">search</span>
      </button>
    </transition>
  </form>
</template>
